(function () {
  var CADEAU_TYPE = 'cadeau';
  var MAX_QTY = 1;

  function isCadeau(item) {
    return item.product_type && item.product_type.trim().toLowerCase() === CADEAU_TYPE;
  }

  function enforceLimit() {
    fetch(window.routes.cart_url + '.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var variantTotals = {};
        cart.items.forEach(function (item) {
          if (isCadeau(item)) {
            var vid = String(item.variant_id);
            variantTotals[vid] = (variantTotals[vid] || 0) + item.quantity;
          }
        });
        var updates = {};
        var dirty = false;
        Object.keys(variantTotals).forEach(function (vid) {
          if (variantTotals[vid] > MAX_QTY) {
            updates[vid] = MAX_QTY;
            dirty = true;
          }
        });
        if (dirty) {
          return fetch(window.routes.cart_update_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function () {
            window.location.reload();
          });
        }
      })
      .catch(function () {});
  }

  var _origFetch = window.fetch;
  window.fetch = function (url) {
    var result = _origFetch.apply(this, arguments);
    if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1)) {
      result.then(function () {
        setTimeout(enforceLimit, 250);
      }).catch(function () {});
    }
    return result;
  };

  document.addEventListener('DOMContentLoaded', enforceLimit);
})();